import request from 'superagent'

import endpoints from '../config/endpoints'

export default ({ lite, origin }) =>
  new Promise((resolve, reject) =>
    request
      .get(`${origin || ''}${endpoints.meganav}`)
      .then((result) => {
        if (!result.body) {
          return reject(new Error(`Invalid response: ${result.body}`))
        }

        let meganav = result.body.body.data

        if (lite) {
          meganav = meganav.map((category) => ({
            title: category.title,
            link: category.link,
            columns: [],
          }))
        }

        return resolve(meganav)
      })
      .catch((error) => reject(new Error(error))),
  )
